'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _SubFooter = require('shared/components/SubFooter/SubFooter');

var _SubFooter2 = _interopRequireDefault(_SubFooter);

var _NotFound = require('shared/components/NotFound');

var _NotFound2 = _interopRequireDefault(_NotFound);

var _Svg = require('shared/components/Svg');

var _Tutorial = require('shared/components/Tutorial');

var _config = require('config');

var _actions = require('./actions');

var _selectors = require('./selectors');

var _utils = require('./utils');

var _PageFooter = require('../PageFooter');

var _PageFooter2 = _interopRequireDefault(_PageFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'page';

var Page = function (_Component) {
  (0, _inherits3.default)(Page, _Component);

  function Page(props) {
    (0, _classCallCheck3.default)(this, Page);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Page.__proto__ || (0, _getPrototypeOf2.default)(Page)).call(this, props));

    _this._handleScroll = function () {
      var viewed = _this.state.viewed;

      var title = _this.props.page.header.content;
      var pathname = _this.props.location.pathname;

      if (document.getElementById('job-map-container')) {
        if (document.getElementById('job-map-container').getBoundingClientRect().top < window.innerHeight && !viewed) {
          ga('send', 'event', 'Scroll', 'Job Map', /<h3>(.*?)<\/h3>/.exec(title)[1]);
          ga('send', 'pageview', '/job/map/' + pathname.split('/')[2]);
          _this.setState({ viewed: true });
        }
      }
    };

    _this.state = {
      viewed: false,
      lastLocation: props.location.pathname
    };
    return _this;
  }

  (0, _createClass3.default)(Page, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var viewed = this.state.viewed;


      if (typeof window !== 'undefined') {
        window.addEventListener('scroll', this._handleScroll);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var _state = this.state,
          viewed = _state.viewed,
          lastLocation = _state.lastLocation;

      var pathname = this.props.location.pathname;

      if (pathname !== lastLocation) {
        this.setState({
          viewed: false,
          lastLocation: pathname
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', this._handleScroll);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          route = _props.route,
          page = _props.page,
          location = _props.location;
      var loading = page.loading,
          error = page.error,
          image = page.image,
          section = page.section,
          title = page.title,
          defaultIcon = page.defaultIcon,
          subsectorTitle = page.subsectorTitle,
          subsectorSubtitle = page.subsectorSubtitle,
          header = page.header,
          body = page.body,
          sidebar = page.sidebar,
          footer = page.footer,
          subfooter = page.subfooter,
          sidebarFirst = page.sidebarFirst,
          navigation = page.navigation;


      var sidebarShouldDisplayFirst = sidebarFirst === undefined ? 0 : sidebarFirst;

      if (loading) {
        return _react2.default.createElement(
          'section',
          { className: CLASS_NAME + ' ' + route },
          _react2.default.createElement(
            'div',
            { className: 'wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'page-container' },
              _react2.default.createElement(
                'div',
                { className: 'loading' },
                _react2.default.createElement(
                  'div',
                  { className: 'loader-text' },
                  'Loading Your Page'
                ),
                _react2.default.createElement('div', { className: 'loader' })
              )
            )
          )
        );
      } else if (error) {
        return _react2.default.createElement(_NotFound2.default, { route: route });
      }

      var bodyClass = [CLASS_NAME + '-body', 'page-' + route].join(' ');

      var fullWidth = (sidebar || []).length === 0 ? 'full-width' : '';

      var altIcon = _react2.default.createElement(_Svg.Svg, { image: 'holdCoin' });

      var sidebarContent = (0, _utils.getModuleContainer)({
        modules: sidebar,
        containerClass: CLASS_NAME + '-sidebar',
        route: route
      });

      return _react2.default.createElement(
        'section',
        { className: CLASS_NAME + ' ' + route },
        _react2.default.createElement(_Tutorial.TutorialOverlay, { loading: this.props.page.loading, location: location }),
        (0, _utils.getSection)(section),
        _react2.default.createElement(
          'div',
          { className: 'wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'hero' },
            _react2.default.createElement(
              'div',
              null,
              (0, _utils.getImage)(image) || altIcon
            ),
            _react2.default.createElement(
              'h1',
              null,
              title
            ),
            _react2.default.createElement(
              'div',
              { className: 'subsector-only' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', { src: defaultIcon, alt: '' })
              ),
              _react2.default.createElement(
                'h1',
                null,
                subsectorTitle
              ),
              _react2.default.createElement(
                'h2',
                null,
                subsectorSubtitle
              )
            )
          )
        ),
        (0, _utils.getNavigation)(navigation),
        _react2.default.createElement(
          'div',
          { className: 'wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'page-container ' + fullWidth },
            _react2.default.createElement(
              'div',
              { className: 'heading-container' },
              _react2.default.createElement('div', {
                dangerouslySetInnerHTML: {
                  __html: (header || {}).content
                }
              })
            ),
            sidebarShouldDisplayFirst ? _react2.default.createElement(
              'aside',
              null,
              sidebarContent
            ) : null,
            _react2.default.createElement(
              'div',
              { className: 'primary-column' },
              (0, _utils.getModuleContainer)({
                modules: body,
                containerClass: bodyClass,
                route: route
              })
            ),
            !sidebarShouldDisplayFirst ? _react2.default.createElement(
              'aside',
              null,
              sidebarContent
            ) : null
          ),
          (0, _utils.getModuleContainer)({
            modules: footer,
            containerClass: CLASS_NAME + '-footer',
            component: _PageFooter2.default,
            route: route
          })
        ),
        (0, _utils.getModuleContainer)({
          modules: subfooter,
          containerClass: CLASS_NAME + '-subfooter',
          component: _SubFooter2.default,
          route: route
        })
      );
    }
  }]);
  return Page;
}(_react.Component);

// This is for the initial page load


exports.default = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    var pathname = getState().routing.locationBeforeTransitions.pathname;
    if (!(0, _actions.isPageLoaded)(getState(), pathname)) {
      if (!_config.CLIENT) {
        promises.push(dispatch((0, _actions.fetchPage)(pathname)));
      } else {
        dispatch((0, _actions.fetchPage)(pathname));
      }
    }
    return _promise2.default.all(promises);
  }
}], 'page')((0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(Page));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Page/Page.jsx
// module id = 1101
// module chunks = 0